




































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Watch } from "vue-property-decorator";
import { storeSupervisiAmbulans } from "@/store/modules/SupervisiAmbulansStore";
import SupervisiAmbulansSvc from "@/services/SupervisiAmbulansService";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";
import {
  SupervisiAmbulansKategori,
  KATEGORI_LABEL,
} from "@/types/SupervisiAmbulans";

const JAM_CARRIER = toDateString(new Date()) || "2000-01-01";

@Component({ components: { CardModalTtd, VCDateTimePicker } })
export default class SupervisiAmbulansFormPage extends Vue {
  parent: any = {
    nomor_formulir: "",
    tanggal_supervisi: localISODate(),
    waktu_mulai: "",
    waktu_selesai: "",
    supervisor_jabatan: "",
    kepala_unit_nama_manual: "",
    temuan_utama: "",
    rencana_tindak_lanjut: "",
  };
  itemsDraft: any[] = [];
  saving = false;
  showTtdModal = false;
  signRole: "supervisor" | "kepala-unit" = "supervisor";

  kategoriOrder: SupervisiAmbulansKategori[] = [
    "fasilitas-apd",
    "kebersihan-ambulan",
    "kepatuhan-petugas",
  ];
  kategoriLabel = KATEGORI_LABEL;

  get routeId() {
    return this.$route.params.id;
  }

  get isNew() {
    return this.routeId === "baru";
  }

  get current() {
    return storeSupervisiAmbulans.currentItem;
  }

  get locked() {
    return !!(this.current && this.current.is_locked);
  }

  get supervisorName() {
    if (this.current && this.current.supervisor) return this.current.supervisor.nama || "";
    return userModule.user?.nama || "";
  }

  async mounted() {
    if (!this.isNew) {
      await this.load();
    }
  }

  @Watch("$route.params.id")
  async onRouteIdChange(newId: string) {
    if (newId && newId !== "baru") {
      await this.load();
    }
  }

  async load() {
    await storeSupervisiAmbulans.refresh(Number(this.routeId));
    if (this.current) {
      this.parent = {
        nomor_formulir: this.current.nomor_formulir,
        tanggal_supervisi: this.current.tanggal_supervisi,
        waktu_mulai: this.trimTime(this.current.waktu_mulai) || "",
        waktu_selesai: this.trimTime(this.current.waktu_selesai) || "",
        supervisor_jabatan: this.current.supervisor_jabatan || "",
        kepala_unit_nama_manual: this.current.kepala_unit_nama_manual || "",
        temuan_utama: this.current.temuan_utama || "",
        rencana_tindak_lanjut: this.current.rencana_tindak_lanjut || "",
      };
      this.itemsDraft = (this.current.items || []).map(i => ({ ...i }));
    }
  }

  get tanggalSupervisiDate(): Date | null {
    return composeDate(this.parent.tanggal_supervisi);
  }
  set tanggalSupervisiDate(val: Date | null) {
    this.parent.tanggal_supervisi = toDateString(val) || "";
  }

  get waktuMulaiDate(): Date | null {
    if (!this.parent.waktu_mulai) return null;
    return composeDate(JAM_CARRIER, this.trimTime(this.parent.waktu_mulai));
  }
  set waktuMulaiDate(val: Date | null) {
    this.parent.waktu_mulai = toTimeString(val);
  }

  get waktuSelesaiDate(): Date | null {
    if (!this.parent.waktu_selesai) return null;
    return composeDate(JAM_CARRIER, this.trimTime(this.parent.waktu_selesai));
  }
  set waktuSelesaiDate(val: Date | null) {
    this.parent.waktu_selesai = toTimeString(val);
  }

  trimTime(v: string | null | undefined): string | null {
    if (!v) return null;
    const s = String(v).trim();
    return s.length >= 5 ? s.substring(0, 5) : null;
  }

  itemsByKategori(kategori: SupervisiAmbulansKategori) {
    return this.itemsDraft
      .filter(i => i.kategori === kategori)
      .sort((a, b) => a.urutan - b.urutan);
  }

  async saveNew() {
    this.saving = true;
    try {
      const payload: any = {
        tanggal_supervisi: this.parent.tanggal_supervisi,
        waktu_mulai: this.trimTime(this.parent.waktu_mulai),
        waktu_selesai: this.trimTime(this.parent.waktu_selesai),
        supervisor_user_id: userModule.user.id,
        supervisor_jabatan: this.parent.supervisor_jabatan || null,
        kepala_unit_nama_manual: this.parent.kepala_unit_nama_manual || null,
      };
      const resp = await SupervisiAmbulansSvc.create(payload);
      const id = resp.data.data.id;
      this.$router.replace({ name: "supervisi-ambulans-form", params: { id: String(id) } });
      // after route change, mounted runs again
    } finally {
      this.saving = false;
    }
  }

  async saveDraft() {
    if (!this.current) return;
    this.saving = true;
    try {
      await SupervisiAmbulansSvc.update(this.current.id, {
        tanggal_supervisi: this.parent.tanggal_supervisi,
        waktu_mulai: this.trimTime(this.parent.waktu_mulai),
        waktu_selesai: this.trimTime(this.parent.waktu_selesai),
        supervisor_jabatan: this.parent.supervisor_jabatan || null,
        kepala_unit_nama_manual: this.parent.kepala_unit_nama_manual || null,
        temuan_utama: this.parent.temuan_utama || null,
        rencana_tindak_lanjut: this.parent.rencana_tindak_lanjut || null,
      });
      await SupervisiAmbulansSvc.updateItems(
        this.current.id,
        this.itemsDraft.map(i => ({
          id: i.id,
          hasil: i.hasil || null,
          masalah: i.masalah || null,
          rekomendasi: i.rekomendasi || null,
        }))
      );
      await this.load();
    } finally {
      this.saving = false;
    }
  }

  openSign(role: "supervisor" | "kepala-unit") {
    this.signRole = role;
    this.showTtdModal = true;
  }

  async onSignPassword(password: string) {
    if (!this.current) return;
    this.saving = true;
    try {
      // Auto-save items first so the signed version reflects latest edits
      if (!this.locked) {
        await this.saveDraft();
      }
      if (this.signRole === "supervisor") {
        await SupervisiAmbulansSvc.signSupervisor(this.current.id, { password });
      } else {
        // assign kepala unit to current user if empty
        if (!this.current.kepala_unit_user_id) {
          await SupervisiAmbulansSvc.update(this.current.id, {
            kepala_unit_user_id: userModule.user.id,
          });
        }
        await SupervisiAmbulansSvc.signKepalaUnit(this.current.id, { password });
      }
      appModule.addMsgTtd("");
      await this.load();
    } catch (e) {
      const msg = (e as any)?.response?.data?.message || "Gagal menandatangani";
      appModule.addMsgTtd(msg);
      this.showTtdModal = true;
    } finally {
      this.saving = false;
    }
  }

  printPdf() {
    if (this.current) SupervisiAmbulansSvc.printPdf(this.current.id);
  }

  back() {
    this.$router.push({ name: "supervisi-ambulans-list" });
  }

  formatDt(dt?: string | null) {
    if (!dt) return "";
    const d = new Date(dt);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
}
